module.exports = __webpack_public_path__ + "static/img/IMG_20241030_175907.b968d2e2.jpg";